import styled from '@emotion/styled';
import Link, { LinkProps } from '@ep/components/Link';
import theme from '@ep/theme';
import React from 'react';

export interface HeaderLinkProps extends LinkProps {}

const StyledLink = styled(Link)`
  padding: 1rem;
  font-size: ${theme.typography.toRem(13)};
  color: ${theme.colors.darkBlue};
  transition: ${theme.transitions.create(['color'])};

  :hover {
    color: ${theme.colors.mediumBlue};
  }

  ${theme.mediaQueries.mobile} {
    display: none;
  }
`;

function HeaderLink(props: HeaderLinkProps) {
  return <StyledLink {...props} />;
}

export default HeaderLink;
